export default __webpack_public_path__ + "static/media/bird.9dc0436d.mp3";